<template>
    <div>
        <h3 class="is-size-4 pt-5 has-text-weight-bold">
            CUENTA BANCARIA EMPRESA
        </h3>
        <p class="mb-5">
            Automatiza tus saldos con
            <FintocLogo style="width:72px;margin-bottom:-8px;" />
        </p>
        <p class="mt-6 has-text-weight-bold">
            Conéctate para ver saldos y movimientos bancarios actualizados
            automáticamente
        </p>
        <br />
        <p>
            Nuestros robots van a buscar tus datos cada 60 minutos a tus bancos.
            Te ayudamos a llevar la conciliación bancaria en línea
        </p>
        <div
            v-if="widgetSuccessfull && !isSuccessful"
            class="is-flex is-justify-content-center p-5"
        >
            <b-button
                type="is-flow"
                rounded
                :loading="loadingFintoc"
                v-on:click="onConnect"
                >Conectarse</b-button
            >
        </div>
        <b-message
            id="successMsgAutomatic"
            type="is-success"
            class="is-size-6 my-5 filterMessageCustomMessage"
            size="is-small"
            has-icon
            icon="info-circle"
            v-show="isSuccessful"
        >
            Tu cuenta bancaria fue agregada con éxito
        </b-message>
        <b-message
            type="is-danger"
            class="is-size-6 mt-5 filterMessageCustomMessage"
            size="is-small"
            has-icon
            v-show="!widgetSuccessfull"
            icon="info-circle"
        >
            Momentáneamente no es posible ingresar una cuenta bancaria
            automática.
        </b-message>
    </div>
</template>

<script>
import FintocLogo from "@/components/svg/FintocLogo.vue";

export default {
    name: "AutomaticUpload",
    components: {
        FintocLogo,
    },
    props: {
        loadingFintoc: {
            type: Boolean,
            default: false,
        },
        isSuccessful: {
            type: Boolean,
            default: false,
        },
        widgetSuccessfull: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        onConnect: function() {
            this.$emit("on-connect");
        },
    },
};
</script>
